import React from 'react'
import SearchFilter from './search-filter'
import { get } from 'lodash'

const NameFilter = ({
    value = '',
    onChange = () => {},
    disabled
}) => {
    return (
        <SearchFilter
            title='Search'
            value={get(value, 'name')}
            onChange={v => onChange({ ...value, name: v})}
            disabled={disabled}
            addButton={true}
        />
    )
}

export default NameFilter